import React from 'react'

const faqs = [
  {
    question: "What makes Color Kingdon colouring books special?",
    answer:
      "Our books feature unique hand-drawn illustrations by talented artists, premium thick paper that prevents bleed-through, and themes designed to spark creativity for kids and adults alike.",
  },
  {
    question: "What quality of paper do you use?",
    answer:
      "Yes! We use 100% premium, thick, acid-free paper perfect for crayons, colored pencils, markers, and gel pens. No bleed-through or show-through guaranteed!",
  },
  {
    question: "Are your books suitable for all ages?",
    answer:
      "Absolutely! We offer Kids Collection (ages 3-10), Advanced Books for teens/adults, and Theme-Based books suitable for all ages and skill levels.",
  },
  {
    question: "What themes do you offer?",
    answer:
      "Exciting themes including Animals 🐯, Nature 🌿, Fantasy 🧚, Mandalas, Festivals 🎉, and educational designs that teach shapes, numbers, and letters to kids.",
  },
  {
    question: "How thick are the pages?",
    answer:
      "Our pages are 120-160 GSM thickness - perfect for heavy colouring without damaging the next page. Professional quality for home or classroom use.",
  },
  {
    question: "What is your mission at Color Kingdon?",
    answer:
      "To make creativity accessible to everyone! We create high-quality colouring books that boost imagination, relieve stress, improve focus, and provide screen-free entertainment.",
  },
  {
    question: "Can these books be used with markers?",
    answer:
      "Yes! Our bleed-proof paper works perfectly with water-based markers, alcohol markers, gel pens, colored pencils, and crayons. Single-sided printing on many pages too!",
  },
  {
    question: "Are your books made in India?",
    answer:
      "Yes, proudly made in India with love! Supporting local artists and using the finest materials while keeping prices affordable for Indian families.",
  },
  {
    question: "What makes your kids' books educational?",
    answer:
      "Our kids' books teach through play! Designs include numbers, letters, shapes, animals, and basic concepts while keeping colouring fun and engaging.",
  },
  {
    question: "Do you offer bulk orders for schools/events?",
    answer:
      "Yes! Perfect for classrooms, birthday return gifts, corporate gifting, and events. Contact us for special pricing on bulk orders of 50+ books.",
  }
];

function Faqsection() {
  return (
    <>
    <section className="row px-sm-5 py-5 faq">
      <div className="px-sm-5">
        <div className="text-center about-title">
          <h2 className="title">Frequently Asked Questions</h2>
          <p>Get Answers to Common Queries About Our Colouring Books</p>
        </div>
      </div> 

      <div className="accordion" id="faqAccordion">
        {faqs.map((faq, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header">
              <button
                className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#faq${index}`}
              >
                {faq.question}
              </button>
            </h2>
            <div
              id={`faq${index}`}
              className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">{faq.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
    </>
  )
}

export default Faqsection